<template>
    <div class="flex justify-start">
        <dropdown-menu>
            <div class="py-1">
                <MenuItem>
                    <Link
                        :href="route('bookings.show', data.id)"
                        class="hover:bg-gray-200 text-gray-700 block px-4 py-2 text-sm"
                    >
                        {{ trans("bookings.table.actions.show") }}
                    </Link>
                </MenuItem>

                <MenuItem>
                    <a
                        download
                        :href="route('bookings.contract', data.id)"
                        class="hover:bg-gray-200 text-gray-700 block px-4 py-2 text-sm cursor-pointer"
                    >
                        {{ trans("bookings.table.actions.download_contract") }}
                    </a>
                </MenuItem>

                <MenuItem v-if="!data.total_paid_at">
                    <a
                        @click.prevent="markAsPaid(data.id)"
                        class="hover:bg-gray-200 text-gray-700 block px-4 py-2 text-sm cursor-pointer"
                    >
                        {{ trans("bookings.table.actions.mark_as_paid") }}
                    </a>
                </MenuItem>

                <MenuItem v-if="!data.is_done">
                    <a
                        @click.prevent="markAsDone(data.id)"
                        class="hover:bg-gray-200 text-gray-700 block px-4 py-2 text-sm cursor-pointer"
                    >
                        {{ trans("bookings.table.actions.mark_as_done") }}
                    </a>
                </MenuItem>

                <MenuItem>
                    <a
                        @click.prevent="deleteUser(data.id)"
                        class="hover:bg-gray-200 text-gray-700 block px-4 py-2 text-sm cursor-pointer"
                    >
                        {{ trans("bookings.table.actions.delete") }}
                    </a>
                </MenuItem>
            </div>
        </dropdown-menu>
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import Swal from "sweetalert2";
import DropdownMenu from "@/Components/DropdownMenu";
import { MenuItem } from "@headlessui/vue";

export default {
    components: {
        Link,
        DropdownMenu,
        MenuItem,
    },

    props: {
        data: {
            type: Object,
        },
        index: {
            type: Number,
        },
    },

    methods: {
        markAsPaid(id) {
            Swal.fire({
                title: this.trans("confirmation.title"),
                text: this.trans("confirmation.mark_as_paid"),
                icon: "warning",
                iconColor: "#D64A0A",
                showCancelButton: true,
                cancelButtonColor: "#6e788188",
                confirmButtonColor: "#D64A0A",
                confirmButtonText: this.trans("confirmation.yes"),
                cancelButtonText: this.trans("confirmation.no"),
            }).then((result) => {
                if (result.isConfirmed) {
                    axios
                        .get(this.route("bookings.mark-as-paid", id))
                        .then(() => this.$emit("refresh"));
                }
            });
        },

        markAsDone(id) {
            Swal.fire({
                title: this.trans("confirmation.title"),
                text: this.trans("confirmation.mark_as_done"),
                icon: "warning",
                iconColor: "#D64A0A",
                showCancelButton: true,
                cancelButtonColor: "#6e788188",
                confirmButtonColor: "#D64A0A",
                confirmButtonText: this.trans("confirmation.yes"),
                cancelButtonText: this.trans("confirmation.no"),
            }).then((result) => {
                if (result.isConfirmed) {
                    axios
                        .get(this.route("bookings.mark-as-done", id))
                        .then(() => this.$emit("refresh"));
                }
            });
        },

        deleteUser(id) {
            Swal.fire({
                title: this.trans("confirmation.title"),
                text: this.trans("confirmation.delete"),
                icon: "warning",
                iconColor: "#D64A0A",
                showCancelButton: true,
                cancelButtonColor: "#6e788188",
                confirmButtonColor: "#D64A0A",
                confirmButtonText: this.trans("confirmation.yes"),
                cancelButtonText: this.trans("confirmation.no"),
            }).then((result) => {
                if (result.isConfirmed) {
                    axios
                        .delete(this.route("bookings.destroy", id))
                        .then(() => this.$emit("refresh"));
                }
            });
        },
    },
};
</script>
